import { Component, Input, OnInit } from '@angular/core';
import { HeaderComponent } from '../../shared/header/header.component';
import { FooterComponent } from '../../shared/footer/footer.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { StyleDirectionService } from '../../services/style-direction.service';
import { ItemService } from '../../appshared/invoice/item/item.service';
import { ActivatedRoute } from '@angular/router';
import { ItemModule } from '../../appshared/invoice/item/item.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faShoppingCart,
  faThLarge,
  faThList,
  faAngleDown,
} from '@fortawesome/free-solid-svg-icons';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ItemPictureService } from '../../appshared/invoice/item-picture/item-picture.service';
import { ItemPictureModule } from '../../appshared/invoice/item-picture/item-picture.module';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'app-pages',
  standalone: true,
  imports: [
    HeaderComponent,
    FooterComponent,
    FontAwesomeModule,
    RouterModule,
    CommonModule,
    TranslateModule,
  ],
  templateUrl: './pages.component.html',
  styleUrl: './pages.component.css',
})
export class PagesComponent implements OnInit {
  Direction: string = 'ltr';
  items: ItemModule[] = [];
  categoryId!: number;
  itemPictures: ItemPictureModule[] = [];
  itemId!: number;
  public apiURL: string = '';
  ComID: number = 1;
  currentLang: string = localStorage.getItem('locale') || 'en';
  categoryName: string | undefined;
  categoryNameAr: string | undefined;

  constructor(
    private translate: TranslateService,
    private styleDirectionService: StyleDirectionService,
    private route: ActivatedRoute,
    private itemService: ItemService,
    private itemPictureService: ItemPictureService
  ) {
    const storedLang = localStorage.getItem('locale') || 'ar';
    this.translate.setDefaultLang(storedLang);
    this.translate.use(storedLang);

    this.setDirectionAndStyles(storedLang);
  }

  setDirectionAndStyles(storedLang: string) {
    if (storedLang === 'ar') {
      this.Direction = 'rtl';
      this.styleDirectionService.fillData(true);
    } else {
      this.Direction = 'ltr';
      this.styleDirectionService.fillData(false);
    }
  }

  // *** items ***

  faShoppingCart = faShoppingCart;
  faThLarge = faThLarge;
  faThList = faThList;
  faAngleDown = faAngleDown;

  viewMode: 'grid' | 'list' = 'grid';

  dropdownOpen = false;

  currentSort = 'default';

  setViewMode(mode: 'grid' | 'list') {
    this.viewMode = mode;
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  trackByFn(index: number, item: any) {
    return item.id;
  }
  // *** end of items ***

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.apiURL =
        environment.apiUrl2 + 'Attachment/Companies/' + this.ComID + '/Items/';
      this.categoryId = +params['CID'];
      this.fetchItemsByCategory();
      this.fetchItemPictures();
    });
  }

  fetchItemsByCategory(): void {

    this.items = [];

    this.itemService
      .getServiceCategory(1, this.categoryId, 'Default')
      .subscribe(
        (items) => {
         
          this.items = items;
          this.sortItems(this.currentSort);
          this.categoryName = items[0].categoryName;
          this.categoryNameAr = items[0].categoryNameAr;
        },
        (error) => {
          
          console.error('Error fetching items:', error);
        }
      );
  }

  sortItems(order: string): void {
    this.currentSort = order;
    if (order === 'lowToHigh') {
      this.items.sort((a, b) => a.salesPrice! - b.salesPrice!);
    } else if (order === 'highToLow') {
      this.items.sort((a, b) => b.salesPrice! - a.salesPrice!);
    } else {
      this.items = [...this.items];
    }
  }

  fetchItemPictures(): void {
    this.itemPictureService.getServiceID(this.itemId).subscribe(
      (pictures) => {
        this.itemPictures = pictures;
      },
      (error) => {
        console.error('Error fetching item pictures:', error);
      }
    );
  }
}
